import React, { useState, useMemo, useEffect, createContext, useContext } from 'react';
import rosetta from 'rosetta';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var I18nContext = createContext();
var I18n = function I18n(rosettaOpts) {
  var r = rosetta(rosettaOpts);
  return {
    /**
     * Triggers a render cycle
     */
    _onUpdate: function _onUpdate() {},

    /**
     * Retrieve a translation segment for the active language
     */
    t: r.t,

    /**
     * Get the table of translations for a language
     */
    table: r.table,

    /**
     * Define or extend the language table
     */
    set: r.set,

    /**
     * Set a locale or returns the active locale
     */
    locale: function locale(_locale) {
      if (_locale === undefined) {
        return r.locale();
      }

      var activelocale = r.locale(_locale);

      this._onUpdate();

      return activelocale;
    },

    /**
     * Returns an i18n instance that treats number values as pluralization
     */
    withPlural: function withPlural(pluralRulesOptions) {
      var _this = this;

      if (pluralRulesOptions === void 0) {
        pluralRulesOptions = {
          type: 'ordinal'
        };
      }

      var PR = new Intl.PluralRules(r.locale(), pluralRulesOptions);
      return function (key, params) {
        Object.keys(params).map(function (k) {
          if (typeof params[k] === 'number') {
            var pkey = PR.select(params[k]);
            params[k] = _this.t(k + "." + pkey);
          }
        });
        return _this.t.apply(_this, [key, params].concat([].slice.call(arguments, 2)));
      };
    }
  };
};
function I18nProvider(_ref) {
  var children = _ref.children,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en' : _ref$locale,
      lngDict = _ref.lngDict,
      i18nInstance = _ref.i18nInstance;

  var _useState = useState(0),
      setTick = _useState[1];

  var i18n = useMemo(function () {
    var instance = i18nInstance != null ? i18nInstance : I18n();

    instance._onUpdate = function () {
      return setTick(function (tick) {
        return tick + 1;
      });
    };

    instance.set(locale, lngDict);
    instance.locale(locale);
    return instance; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18nInstance]);
  useEffect(function () {
    i18n.set(locale, lngDict);
    i18n.locale(locale); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, lngDict]);
  return /*#__PURE__*/React.createElement(I18nContext.Provider, {
    value: _extends({}, i18n)
  }, children);
}

function useI18n() {
  var i18n = useContext(I18nContext);
  return i18n;
}

export { I18n, I18nProvider, useI18n };
